<template>
  <li
    class="anz-posts__item"
    :class="{
      'anz-posts__item--advert':
        advert && advert.renderAfter && postRoot.fullyLoaded,
      'anz-posts__item--no-posts': !postRoot.post,
      'anz-posts__item--has-children': postRoot.children.length > 0,
    }"
  >
    <template v-if="!disableAdvert && advert && !advert.renderAfter">
      <advert-position :advert="advert" :key="advert.divId"> </advert-position>
    </template>
    <post-single
      v-if="postRoot.post"
      :post-root="postRoot"
      @post-responded="postResponded($event)"
      show-report-button
      show-subscribe-button
      highlight-mine
      :allow-show-new="allowShowNew"
      :show-parent-author-ref="level > 5"
      :open-respond-page="openRespondPage"
      :show-redirect-to-thread-button="showRedirectToThreadButton"
      :strip-long-text="stripLongText"
    >
    </post-single>
    <template v-if="postRoot.children.length > 0">
      <ul
        :class="[
          'level-' + currentLevel,
          {
            'anz-ul--last-item': index === postRoot.children.length - 1,
          },
        ]"
        v-for="(postRootChildren, index) in postRoot.children"
        :key="postRootChildren.id"
      >
        <post-list-branch
          :post-root="postRootChildren"
          :allow-show-new="allowShowNew"
          :level="level + 1"
          :disable-advert="disableAdvert"
        ></post-list-branch>
      </ul>
    </template>
    <template
      v-if="
        !disableAdvert && advert && advert.renderAfter && postRoot.fullyLoaded
      "
    >
      <advert-position :advert="advert" :key="advert.divId"> </advert-position>
    </template>
  </li>
</template>

<script lang="ts">
import { computed, defineComponent, Ref, ref } from 'vue'
import PostSingle from '@/components/Post/PostSingle.vue'
import { Post } from '@/model/data-object/Post'
import AdvertPosition from '@/components/Post/AdvertPosition.vue'
import useAdvertManager from '@/composables/advert/advertManager'
import useConfiguration from '@/composables/configuration/configuration'

const { configuration } = useConfiguration()

export default defineComponent({
  name: 'PostListBranch',
  components: { AdvertPosition, PostSingle },
  emits: ['post-responded'],
  props: {
    postRoot: {
      type: Object, // todo retype to postRoot
      required: true,
    },
    showRedirectToThreadButton: {
      type: Boolean,
      default: false,
    },
    openRespondPage: {
      type: Boolean,
      default: false,
    },
    allowShowNew: {
      type: Boolean,
      default: false,
    },
    stripLongText: {
      type: Boolean,
      default: false,
    },
    disableAdvert: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      collapsed: false,
      currentLevel:
        configuration.maxPostTreeDepth < this.level
          ? configuration.maxPostTreeDepth
          : this.level,
    }
  },
  async setup(props, context) {
    const isTopLevelNonRoot: Ref<boolean> = ref<boolean>(false)
    const { advertPositionsList } = useAdvertManager()

    isTopLevelNonRoot.value =
      props.postRoot.post && props.postRoot.post.parent !== null

    const postResponded = function(post: Post) {
      context.emit('post-responded', post)
    }

    const advert = computed(() => {
      if (props.postRoot.id in advertPositionsList) {
        return advertPositionsList[props.postRoot.id]
      }
    })

    return {
      isTopLevelNonRoot,
      advert,
      postResponded,
    }
  },
})
</script>
